import { useEffect, useState } from 'react';

import { csrClient } from '../apollo/api/avantArteClient';
import { AvantArteProductGateway } from '../gateways/AvantArteProductGateway';
import { GeneratedTaxType } from '../types/generated';
import { CountryCode } from '../types/Locations';

const productsGateway = new AvantArteProductGateway(csrClient);

export interface TaxTypeDetail {
  taxType: GeneratedTaxType;
  generalTranslationCode: string;
  freeDeliveryTranslationCode: string;
}

const groups: TaxTypeDetail[] = [
  {
    taxType: GeneratedTaxType.Vat,
    generalTranslationCode: 'benefits.fees.feesAtCheckout',
    freeDeliveryTranslationCode: 'benefits.fees.freeDelivery',
  },
  {
    taxType: GeneratedTaxType.Ddp,
    generalTranslationCode: 'benefits.fees.feesAndTaxAtCheckout',
    freeDeliveryTranslationCode: 'benefits.fees.freeDeliveryTaxAtCheckout',
  },
  {
    taxType: GeneratedTaxType.Ddu,
    generalTranslationCode: 'benefits.fees.feeAndTaxNotIncluded',
    freeDeliveryTranslationCode: 'benefits.fees.freeDeliveryWithTax',
  },
  {
    taxType: GeneratedTaxType.NoTax,
    generalTranslationCode: 'benefits.fees.feesAtCheckout',
    freeDeliveryTranslationCode: 'benefits.fees.freeDelivery',
  },
];

export function useTaxTypeTransactionDetails(
  countryCode: CountryCode,
): TaxTypeDetail | undefined {
  const [taxType, setTaxType] = useState<GeneratedTaxType>();

  useEffect(() => {
    productsGateway
      .getTaxesForCountryCode(countryCode)
      .then((t) => t.tax && setTaxType(t.tax.taxType))
      .catch(console.error);
  }, [countryCode]);

  return groups.find((d) => d.taxType === taxType);
}
